import SignatureOptionState from '../store/schema/SignatureOptionState';
import store from '../store/store';
import UserOptionsType from 'owa-service/lib/contract/UserOptionsType';
import { getUserConfiguration } from 'owa-session-store';
import { select } from 'satcheljs/lib/legacy';
import { getFallbackValueIfNull } from 'owa-options-core';

export interface IsSignatureOptionDirtyState {
    optionState: SignatureOptionState;
    userOptions: UserOptionsType;
}

export default select<IsSignatureOptionDirtyState>({
    optionState: () => store,
    userOptions: () => getUserConfiguration().UserOptions,
})(function isSignatureOptionDirty(state?: IsSignatureOptionDirtyState) {
    let { optionState, userOptions } = state;

    return (
        optionState.editorViewState.isDirty ||
        getFallbackValueIfNull(optionState.signNewMails, userOptions.AutoAddSignature) !==
            userOptions.AutoAddSignature ||
        getFallbackValueIfNull(optionState.signReplies, userOptions.AutoAddSignatureOnReply) !==
            userOptions.AutoAddSignatureOnReply
    );
});
